module.exports = __webpack_public_path__ + "img/img_engineering_img1.3ded456e.png";